import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'

// COMPONENTS
import { CoreIcons } from 'components'
import { Typography } from '@telavita-core/react-design-kit'
import { ReactComponent as CheckIcon } from 'static/svg/check-nobg.svg'

import Row from '../Row'

const MenuProfileSwap = ({ actualProfile, personProfiles, onClickSelect }) => {
  const wrapperRef = useRef()
  const buttonRef = useRef()

  const [isOpen, setIsOpen] = useState(false) 

  useEffect(() => {
    function handleClickOutside(event) {
      const buttonIsClicked = buttonRef.current?.contains(event.target)
      const wrapperIsClicked = wrapperRef.current?.contains(event.target)

      if (buttonRef.current && buttonIsClicked) {
        return setIsOpen(prevState => !prevState)
      }

      if (wrapperRef.current && !wrapperIsClicked) {
        setIsOpen(false)
      }
    }
    
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [wrapperRef, buttonRef])

  return (
    <div className="profile-swap">
      <div className="profile-swap--select"
        ref={buttonRef}
      >
        <Row align="center">
          <div className="profile-swap--text">
            <Typography variant='content3'>
              {actualProfile.profile_name}
            </Typography>
          </div>
          <div className="profile-swap--arrow">
            {
              isOpen ?
                <CoreIcons name="ArrowUp" fill="#acacac" width="24px" height="24px" /> :
                <CoreIcons name="ArrowDown" fill="#acacac" width="24px" height="24px" />
            }
          </div>
        </Row>
      </div>
      {
        isOpen ? (
          <div className="profile-swap--option" ref={wrapperRef}>
            {
              personProfiles.map(profile => {
                return (
                  <div key={profile.profile_code}
                    id={`profile-swap--${profile.profile_code}`}
                    className="profile-swap--option--item"
                    onClick={() => onClickSelect(profile.profile_code)}>
                    <Typography variant='content2' inheritColor>
                      {profile.profile_name}
                    </Typography>
                    {profile.profile_code === actualProfile.profile_code && <CheckIcon />}
                  </div>
                )
              })
            }
          </div>
        ) : null
      }
    </div>
  )
}

MenuProfileSwap.propTypes = {
  actualProfile: PropTypes.object,
  isOpen: PropTypes.bool,
  onClickOpen: PropTypes.func,
  onClickSelect: PropTypes.func,
  personProfiles: PropTypes.array,
}

export default MenuProfileSwap